// src/pages/PaymentSuccess.js
import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CheckCircle, ArrowRight } from 'lucide-react';

function PaymentSuccess() {
    const location = useLocation();

    useEffect(() => {
        // Opcional: podrías querer enviar el session_id al backend
        // para una verificación adicional o registro, pero el webhook
        // es la forma principal de confirmación.
        const queryParams = new URLSearchParams(location.search);
        const sessionId = queryParams.get('session_id');
        if (sessionId) {
            console.log("Stripe Session ID:", sessionId);
            // fetch('/api/verify-payment', { method: 'POST', body: JSON.stringify({ session_id: sessionId }) });
        }

         // Podrías querer invalidar caché de datos de usuario aquí
         // para que la próxima carga de /api/me refleje is_premium=true.
         // O simplemente confiar en que el usuario recargue o navegue.

    }, [location]);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-green-900 via-slate-900 to-slate-950 text-white p-6">
            <div className="bg-gray-800/80 backdrop-blur-md border border-green-500/50 rounded-xl shadow-2xl p-8 sm:p-12 text-center max-w-lg">
                <CheckCircle className="w-16 h-16 text-green-400 mx-auto mb-6" />
                <h1 className="text-3xl sm:text-4xl font-extrabold mb-4 text-green-300">¡Pago Exitoso!</h1>
                <p className="text-lg text-gray-300 mb-8">
                    ¡Gracias por actualizar a Premium! Tu cuenta ha sido activada. Ahora tienes acceso a todas las funcionalidades avanzadas.
                </p>
                <Link
                    to="/DesignStudio"
                    className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg text-white font-bold text-lg hover:from-purple-700 hover:to-pink-700 transition-all duration-300 shadow-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-900 focus:ring-purple-500"
                >
                    Ir al Estudio de Diseño
                    <ArrowRight size={20} className="ml-2" />
                </Link>
            </div>
        </div>
    );
}

export default PaymentSuccess;